import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccTableComponent } from './acc-table/acc-table.component';
import { AccSearchTipComponent } from './acc-search-tip/acc-search-tip.component';
import { AccMessageDialogComponent } from './acc-message-dialog/acc-message-dialog.component';
import { AccMaterialsModule } from '../utilities/modules/acc-materials/acc-materials.module';
import { AccStepperComponent } from './acc-stepper/acc-stepper.component';
import { AccStepperStepComponent } from './acc-stepper-step/acc-stepper-step.component';
import { AccCardCollapseComponent } from './acc-card-collapse/acc-card-collapse.component';
import { AccLoaderComponent } from './acc-loader/acc-loader.component';
import { AccConfirmationComponent } from './acc-confirmation/acc-confirmation.component';
import { AccAutoCompleteComponent } from './acc-auto-complete/acc-auto-complete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccRemarksInputComponent } from './acc-remarks-input/acc-remarks-input.component';
import { AccListComponent } from './acc-list/acc-list.component';
import { AccListServiceComponent } from './acc-list/acc-list-service/acc-list-service.component';
import { AccBarchartComponent } from './acc-barchart/acc-barchart.component';
import { AccSplinechartComponent } from './acc-splinechart/acc-splinechart.component';
import { AccPiechartComponent } from './acc-piechart/acc-piechart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AccSimpleInputTextFormComponent } from './acc-simple-input-text-form/acc-simple-input-text-form.component';
import { SimpleFormAutoCompleteInputComponent } from './acc-simple-input-text-form/simple-form-auto-complete-input/simple-form-auto-complete-input.component';
import { SimpleFormDateRangeInputComponent } from './acc-simple-input-text-form/simple-form-date-range-input/simple-form-date-range-input.component';
import { SimpleFormDateInputComponent } from './acc-simple-input-text-form/simple-form-date-input/simple-form-date-input.component';
import { AccCustomPipeModule } from '../utilities/modules/acc-custom-pipe/acc-custom-pipe.module';
import { AccCheckboxComponent } from './acc-checkbox/acc-checkbox.component';
import { AccAutoCompleteInputComponent } from './acc-auto-complete-input/acc-auto-complete-input.component';
import { AccSimpleInputTextFormFixedComponent } from './acc-simple-input-text-form-fixed/acc-simple-input-text-form-fixed.component';



@NgModule({
  declarations: [
    AccTableComponent,
    AccSearchTipComponent,
    AccMessageDialogComponent,
    AccStepperComponent,
    AccStepperStepComponent,
    AccCardCollapseComponent,
    AccLoaderComponent,
    AccConfirmationComponent,
    AccAutoCompleteComponent,
    AccRemarksInputComponent,
    AccListComponent,
    AccListServiceComponent,
    AccBarchartComponent,
    AccSplinechartComponent,
    AccPiechartComponent,
    AccSimpleInputTextFormComponent,
    SimpleFormAutoCompleteInputComponent,
    SimpleFormDateRangeInputComponent,
    SimpleFormDateInputComponent,
    AccCheckboxComponent,
    AccAutoCompleteInputComponent,
    AccSimpleInputTextFormFixedComponent,
  ],
  exports: [
    AccTableComponent,
    AccSearchTipComponent,
    AccMessageDialogComponent,
    AccStepperComponent,
    AccStepperStepComponent,
    AccCardCollapseComponent,
    AccLoaderComponent,
    AccConfirmationComponent,
    AccAutoCompleteComponent,
    AccRemarksInputComponent,
    AccListComponent,
    AccBarchartComponent,
    AccSplinechartComponent,
    AccPiechartComponent,
    AccCheckboxComponent,
    AccAutoCompleteInputComponent,
    AccSimpleInputTextFormFixedComponent,
  ],
  imports: [
    CommonModule,
    AccMaterialsModule,

    FormsModule,
    ReactiveFormsModule,
    AccMaterialsModule,
    AccCustomPipeModule,

    NgApexchartsModule
  ],
})
export class CustomComponentsModule { }
